import React, { useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import Pagination from "../../../Utility/Pagination/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  DeleteUsersubscripedashboardAction,
  getUserSubscriptionAction,
} from "../../../../redux/actions/ManageAdminAction";
import { FormControl, MenuItem, Select } from "@mui/material";
import notify from "../../../Notifcation";
const Display = ({
  setKey,
  setUserid,
  Userid,
  File,
  setFile,
  Base64,
  setBase64,
  isEdit,
  setisEdit,
  QuoteId,
  setQuoteId,
  showDelete,
  setshowDelete,
  showEdit,
  setshowEdit,
  Feedback,
  setFeedback,
  Free,
  setFree,
  Paid,
  setPaid,
  Active,
  setActive,
  val,
  setVal,
  Archivemega,
  setArchivemega,
  Username,
  setUsername,
  moye,
  setDateTwo,
  setmoye,
  setDate2,
  setDate1,
  duration,
  setDuration,
  foc,
  setfoc,
  setIsPress,
  RowId,
  setRowId,
  setAppuserid,
  Appuserid,
  isPress,
  setisValue,
  isValue,
}) => {
  const [Name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [Phone, setPhone] = useState("");

  const [PageSize, setPageSize] = useState(30);
  const [Paidse, setPaidse] = useState(false);
  const [Freese, setFreese] = useState(false);
  const [Activese, setActivese] = useState(false);
  const [Datee1, setDatee1] = useState("");
  const [itemid, setItemid] = useState("");
  const [Datee2, setDatee2] = useState("");
  const dispatch = useDispatch();
  const usersubscribe = useSelector(
    (state) => state.ManageAdminR.UserSubscriber
  );

  const deletesub = useSelector(
    (state) => state.ManageAdminR.DeleteUsersubscripedash
  );

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setItemid(itemid);
  };

  useEffect(() => {
    dispatch(getUserSubscriptionAction(`PageSize=${PageSize}`));
  }, [PageSize]);
  function calculateDaysBetweenDates(date1, date2) {
    // Convert both dates to milliseconds
    var date1Ms = date1.getTime();
    var date2Ms = date2.getTime();

    // Calculate the difference in milliseconds
    var differenceMs = Math.abs(date1Ms - date2Ms);

    // Convert the difference in milliseconds to days
    var days = Math.floor(differenceMs / (1000 * 60 * 60 * 24));

    return days;
  }
  function calculateDaysBetweenDatesLeft(date1, date2) {
    // Convert both dates to milliseconds
    if (date1 < date2) {
      var date1Ms = date1.getTime();
      var date2Ms = date2.getTime();

      // Calculate the difference in milliseconds
      var differenceMs = Math.abs(date1Ms - date2Ms);

      // Convert the difference in milliseconds to days
      var days = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
      return days;
    } else return 0;
  }
  const onPress = async (page) => {
    await dispatch(
      getUserSubscriptionAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  const handleChangelist = (e) => {
    setPageSize(e.target.value);
  };
  function calculateDuration(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    if (months < 0) {
      years--;
      months += 12;
    }

    return { years, months };
  }

  const updateitem = (itemsub) => {
    const date1 = new Date(itemsub.From).toLocaleDateString("en-GB");
    const date2 = new Date(itemsub.To).toLocaleDateString("en-GB");
    const startDate = new Date(itemsub.From);
    const endDate = new Date(itemsub.To);
    const durationn = calculateDuration(startDate, endDate);
    if (durationn.months !== 0) {
      setmoye(1);
      if (durationn.months === 3) {
        setDuration(3);
      }
      if (durationn.months === 6) {
        setDuration(6);
      }
    } else if (durationn.years !== 0) {
      setmoye(2);
      if (durationn.years === 1) {
        setDuration(1);
      }
      if (durationn.years === 2) {
        setDuration(2);
      }
      if (durationn.years === 3) {
        setDuration(3);
      }
    }
    setVal(itemsub.Value);
    setRowId(itemsub.Id);
    setUsername(itemsub.UserName);
    setFeedback(itemsub.Note);
    setDate1(date1);
    setDate2(date2);
    setDateTwo(date2);
    setActive(itemsub.IsActive);
    setFree(itemsub.IsFree);
    setPaid(itemsub.IsPaid);
    setUserid(itemsub.ApplicationUserId);
    setFile(itemsub.SubscriptionFileUrl);
    setArchivemega(itemsub.SubscriptionSizeOnS3);
    setKey("enter");
    setfoc(true);
    setisEdit(true);
    setisValue(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsPress(true);
    await dispatch(
      getUserSubscriptionAction(
        `Name=${Name}&PhoneNumber=${Phone}&IsFree=${Freese}&IsPaid=${Paidse}&IsActive=${Activese}&FromDate=${Datee1}&ToDate=${Datee2}&PageSize=${PageSize}`
      )
    );
    setLoading(false);
    setIsPress(false);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteUsersubscripedashboardAction(itemid));
    await dispatch(
      getUserSubscriptionAction(
        `Name=${Name}&PhoneNumber=${Phone}&IsFree=${Freese}&IsPaid=${Paidse}&IsActive=${Activese}&FromDate=${Datee1}&ToDate=${Datee2}&PageSize=${PageSize}`
      )
    );

    setLoading(false);
    setshowDelete(false);
    setIsPress(false);
  };
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (deletesub && deletesub.length > 0) {
        if (deletesub.StatusCode === 200 || deletesub.StatusCode === 201) {
          if (
            deletesub.ResponseMessage ===
            "User subscription Deleted successfully"
          ) {
            notify("تم الحذف  بنجاح", "success");
          }
        } else if (
          deletesub.StatusCode !== 200 ||
          deletesub.StatusCode !== 201
        ) {
          notify("حدثة مشكلة حاول مرة اخرى", "error");
          // if (
          //   deletesub.ResponseMessage !==
          //   "User subscription Deleted successfully"
          // ) {
          // }
        }
      }
    }
  }, [loading]);
  return (
    <>
      <Container>
        <div className="inputs-container">
          <div className="inp-container dateer ">
            <div className="dateee">
              {Datee1 ? Datee1.split("-").reverse().join("-") : null}
            </div>
            <i className="ty fa-solid fa-calendar-days"></i>
            <TextField
              label="التاريخ من"
              variant="outlined"
              type="date"
              value={Datee1}
              onChange={(e) => setDatee1(e.target.value)}
            />
          </div>
          <div className="inp-container  dateer">
            <div className="dateee">
              {Datee2 ? Datee2.split("-").reverse().join("-") : null}
            </div>
            <i className="ty fa-solid fa-calendar-days"></i>
            <TextField
              label="التاريخ إلى"
              variant="outlined"
              type="date"
              value={Datee2}
              onChange={(e) => setDatee2(e.target.value)}
            />
          </div>
          <div className="inp-container">
            {" "}
            <TextField
              inputProps={{ maxLength: 120 }}
              type="text"
              label={"اسم المستخدم"}
              variant="outlined"
              value={Name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="inp-container ">
            {" "}
            <TextField
              label={"رقم الهاتف"}
              variant="outlined"
              value={Phone}
              onChange={(e) => setPhone(e.target.value)}
              inputProps={{ maxLength: 15 }}
              type="number"
            />
          </div>

          <div className="inp-container ">
            <div className="cch">
              <div className="input-check">
                {" "}
                مجاني
                <input
                  type="checkbox"
                  value={Freese}
                  onChange={(e) => setFreese(e.target.checked)}
                />
              </div>
              <div className="input-check">
                {" "}
                مدفوع
                <input
                  type="checkbox"
                  value={Paidse}
                  onChange={(e) => setPaidse(e.target.checked)}
                />
              </div>
              <div className="input-check">
                {" "}
                مفعل
                <input
                  type="checkbox"
                  value={Activese}
                  onChange={(e) => setActivese(e.target.checked)}
                />
              </div>
            </div>
          </div>
          <div className="inp-container"></div>
        </div>
        {isPress && loading ? (
          <button className="buttonadd">
            <Spinner animation="border" role="status"></Spinner>
          </button>
        ) : (
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        )}
        <hr />
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>
                م<i className="fa-solid fa-hashtag"></i>
              </th>
              {/* <th>
                تاريخ الإنشاء<i className="fa-solid fa-calendar-days"></i>
              </th> */}
              <th>
                بواسطة<i className="fa-solid fa-user-group"></i>
              </th>
              <th>
                المستخدم<i className="fa-solid fa-user-group"></i>
              </th>
              {/* <th>
                كود <i className="fa-solid fa-hashtag"></i>
              </th> */}
              <th>
                رقم الهاتف <i className="fa-solid fa-phone"></i>
              </th>
              <th>
                القيمة<i className="fa-solid fa-layer-group"></i>
              </th>
              <th>
                الأرشيف<i className="fa-solid fa-layer-group"></i>
              </th>
              <th>
                {" "}
                عدد الأيام<i className="fa-solid fa-calendar-days"></i>
              </th>
              <th>
                {" "}
                عدد الأيام المتبقة <i className="fa-solid fa-calendar-days"></i>
              </th>
              <th>
                {" "}
                من<i className="fa-solid fa-user-group"></i>
              </th>
              <th>
                إلى<i className="fa-solid fa-lock"></i>
              </th>

              <th>
                مجاني<i className="fa-solid fa-file-import"></i>
              </th>
              <th>
                مدفوع <i className="fa-solid fa-money-bill"></i>
              </th>
              <th>
                مفعل <i className="fa-solid fa-money-bill"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {usersubscribe &&
            usersubscribe.data &&
            usersubscribe.data.Data.length > 0
              ? usersubscribe.data.Data.map((item, idx) => {
                  // const date = new Date(item.createdDate).toLocaleDateString(
                  //   "en-GB"
                  // );
                  const date1 = new Date(item.From);
                  const date2 = new Date(item.To);
                  // const date = new Date(item.createdDate);
                  const total =
                    (usersubscribe.data.CurrentPage - 1) *
                    usersubscribe.data.ItemsPerPage;
                  return (
                    <tr key={item.Id} onDoubleClick={() => updateitem(item)}>
                      <td>{parseInt(total + 1 + idx)}</td>
                      {/* <td>{date}</td> */}
                      <td>{item.CreatedByName}</td>
                      <td>{item.UserName}</td>
                      {/* <td>0</td> */}
                      <td>{item.UserPhoneNumber}</td>
                      <td>{item.Value}</td>
                      <td>
                        {/* {" "}
                        {item.subscriptionFileUrl !== null ? (
                          <a
                            href={item.subscriptionFileUrl}
                            download
                            target="blank"
                          >
                            {" "}
                            <i className="fa-solid fa-paperclip"></i>
                          </a>
                        ) : (
                          " "
                        )} */}
                        <div className="at-bi">
                          <p>{item.Note !== "null" ? item.Note : " "}</p>
                          {item.SubscriptionFileUrl !== null ? (
                            <a
                              href={item.SubscriptionFileUrl}
                              download
                              target="blank">
                              {" "}
                              <i className="fa-solid fa-paperclip"></i>
                            </a>
                          ) : (
                            " "
                          )}
                        </div>
                      </td>
                      <td> {calculateDaysBetweenDates(date1, date2)} </td>
                      <td>
                        {" "}
                        {calculateDaysBetweenDatesLeft(new Date(), date2)}{" "}
                      </td>
                      <td>{date1.toLocaleDateString("en-GB")}</td>
                      <td>{date2.toLocaleDateString("en-GB")}</td>
                      <td>{item.IsFree ? "مفعل" : "غير مفعل"}</td>
                      <td>{item.IsPaid ? "مفعل" : "غير مفعل"}</td>
                      <td>{item.IsActive ? "مفعل" : "غير مفعل"}</td>
                      <td className="icon-w">
                        <i
                          onClick={() => updateitem(item)}
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "rgb(0 44 146)" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.Id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "red" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        {/* <Pagination PageCount={10} /> */}
        <hr />
        <hr />
        <div className="pag">
          <FormControl style={{ width: "80px", height: "41px" }}>
            {/* <InputLabel id="demo-simple-select-label">
       عدد عناصر الجدول
     </InputLabel> */}
            <Select
              value={PageSize}
              // className="tyt"

              onChange={handleChangelist}>
              <MenuItem value={30}>30</MenuItem>
              <MenuItem value={60}>60</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
          <Pagination
            onPress={onPress}
            PageCount={
              usersubscribe && usersubscribe.date
                ? usersubscribe.date.TotalPages
                : null
            }
          />
        </div>
        {/* <button className="buttonadd">تصدير</button> */}
      </Container>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
        {/* <ToastContainer autoClose={1500}  /> */}
      </div>
    </>
  );
};
export default Display;
